// import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import { enCA, fr } from 'date-fns/locale';
import i18n from '@commonClient2/translations/i18n';
import { updateLocale } from '@commonClient2/services/ukgDateTime';
import commonFr from '@commonClient2/translations/frCommon.json';
import commonEn from '@commonClient2/translations/enCommon.json';
import shiftBiddingEn from './translations/shiftBidding.en.json';
import shiftBiddingFr from './translations/shiftBidding.fr.json';
import tableEn from './translations/table.en.json';
import tableFr from './translations/table.fr.json';
import menuFr from './translations/menu.fr.json';
import menuEn from './translations/menu.en.json';
import globalSetupFr from './translations/globalSetup.fr.json';
import globalSetupEn from './translations/globalSetup.en.json';

i18n.addResourceBundle('fr', 'common', commonFr, true);
i18n.addResourceBundle('en', 'common', commonEn, true);
i18n.addResourceBundle('fr', 'shiftBidding', shiftBiddingFr, true);
i18n.addResourceBundle('en', 'shiftBidding', shiftBiddingEn, true);
i18n.addResourceBundle('fr', 'table', tableFr, true);
i18n.addResourceBundle('en', 'table', tableEn, true);
i18n.addResourceBundle('fr', 'menu', menuFr, true);
i18n.addResourceBundle('en', 'menu', menuEn, true);
i18n.addResourceBundle('fr', 'globalSetup', globalSetupFr, true);
i18n.addResourceBundle('en', 'globalSetup', globalSetupEn, true);

i18n.loadNamespaces('common');
i18n.loadNamespaces('shiftBidding');
i18n.loadNamespaces('table');
i18n.loadNamespaces('menu');
i18n.loadNamespaces('globalSetup');

let locale = enCA;

/**
 * @param {boolean} isEnglish
 */
export const setLocale = (isEnglish) => {
    locale = isEnglish ? enCA : fr;
    const selectedLocale = isEnglish ? 'enCA' : 'fr';
    sessionStorage.setItem('selectedLocale', selectedLocale);
    updateLocale(selectedLocale);
};

export const getLocale = () => locale;
// i18n
//     .use(initReactI18next)
//     .use(LanguageDetector)
//     .init({
//         interpolation: {
//             escapeValue: false,
//         }, // React already does escaping
//         detection: {
//             order: ['localStorage', 'navigator'],
//             lookupLocalStorage: 'language',
//         },
//         resources: {
//             en: {
//                 common: commonEn,
//                 shiftBidding: shiftBiddingEn,
//             },
//             fr: {
//                 common: commonFr,
//                 shiftBidding: shiftBiddingFr,
//             },
//         },
//         fallbackLng: 'en',
//     });

export default i18n;
